<template>
  <div>
    <!--彈出視窗-->
    <v-dialog v-model="visible" persistent :max-width="width">
      <v-card>
        <v-card-title class="headline">
          {{ title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6>
              <v-select
                label="廠牌"
                :items="vendorList"
                item-text="value"
                item-value="key"
                v-model="editedItem.vendor"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select
                label="商品類型"
                :items="typeList"
                item-text="value"
                item-value="key"
                v-model="editedItem.type"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="editedItem.type === 0">
            <v-flex xs6>
              <v-select
                label="機種代號"
                :items="kindList"
                item-text="name"
                item-value="name"
                v-model="editedItem.kind"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select
                label="版本"
                :items="categoryList"
                item-text="value"
                item-value="key"
                v-model="editedItem.category"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="editedItem.type === 1">            
            <v-flex xs6>
              <v-select
                label="ECU群組"
                :items="groupList"
                item-text="value"
                item-value="key"
                v-model="editedItem.groupId"
              ></v-select>
            </v-flex>
          </v-layout>
          <!-- <v-layout row wrap v-if="editedItem.type === 1">
            <v-flex xs6>
              <v-select
                label="分類"
                :items="categoryList"
                item-text="value"
                item-value="key"
                v-model="editedItem.category"
              ></v-select>
            </v-flex>
          </v-layout> -->
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                v-model="editedItem.carName"
                :label="`車名`"
                background-color="#49bcfd"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="editedItem.cc"
                :label="`CC數`"
                background-color="#49bcfd"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                v-model="editedItem.id"
                :label="`商品型號`"
                background-color="#49bcfd"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="editedItem.generalNumber"
                :label="`機種代號`"
                background-color="#49bcfd"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="editedItem.type === 1">
            <v-flex xs6>
              <v-text-field
                v-model="editedItem.caliber"
                :label="`口徑`"
                background-color="#49bcfd"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="editedItem.type === 1">
            <v-flex xs12>
              <span style="color: red">請用逗號(,)分隔. ex.K801,K802</span>
              <v-textarea 
                v-model="editedItem.engineNumber"
                :label="`引擎號碼(英文部分)`"
                background-color="#49bcfd"
                outline
              ></v-textarea >
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="editedItem.type === 1 && editedItem.vendor === 0">
            <v-flex xs12>
              <span style="color: red">請用逗號(,)分隔. ex.K801,K802</span>
              <v-textarea 
                v-model="editedItem.specification"
                :label="`規格`"
                background-color="#49bcfd"
                outline
              ></v-textarea >
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="editedItem.type === 1 && editedItem.vendor === 1">
            <v-flex xs6>
              <v-text-field
                v-model="editedItem.beginEngineNumber"
                :label="`引擎號碼起始編號`"
                background-color="#49bcfd"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="editedItem.type === 1 && editedItem.vendor === 1">
            <v-flex xs6>
              <v-text-field
                v-model="editedItem.endEngineNumber"
                :label="`引擎號碼結束編號`"
                background-color="#49bcfd"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex>
              <v-text-field
                v-model="editedItem.comment"
                :label="`備註`"
                background-color="#49bcfd"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="uploadedFiles.length > 0">
            <v-flex xs12>
              <v-container grid-list-sm fluid>
                <v-layout row wrap>
                  <v-flex v-for="fileInfo in uploadedFiles" :key="fileInfo.sort" xs4 d-flex>
                    <v-card flat tile class="d-flex">
                      <v-img
                        :src="`${fileInfo.url ? fileInfo.url : fileInfo.image}`"
                        aspect-ratio="1"
                        class="grey lighten-2"
                      >
                        <template v-slot:placeholder>
                          <v-layout
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-layout>
                        </template>
                      </v-img>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md12>
                  <div class="dropbox">
                    <input
                      type="file"
                      ref="file"
                      multiple
                      @change="
                        filesChange($event.target.name, $event.target.files)
                      "
                      accept="image/*"
                      class="input-file"
                    />
                    <p>
                      將圖片(一張或多張)拖到此處
                      <br />或點擊合併
                    </p>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark text @click="cancelEvent">取消</v-btn>
          <v-btn color="primary" dark text @click="confirmEvent">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MobileDetect from "mobile-detect";
import RectifierModel from "../models/RectifierModel";
import AttachmentModel from "../models/AttachmentModel";
import common from '../mixins/common'
import { mapActions } from 'vuex';

const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "RectifierEditDialog",
  props: {
    visible: Boolean,
    title: String,
    item: new RectifierModel(),
    categoryList: Array,
    typeList:Array,
    groupList:Array,
  },
  mixins:[common],
  data() {
    return {
      width: md.phone() ? "80%" : "50%",
      uploadedFiles: [],
      //圖片格式
      imageInfo: {
        sort: 0,
        url: "",
        image: "",
      },
      kindList:[],
    };
  },
  computed: {
    editedItem() {
      return this.item;
    },
  },
  watch: {
    'editedItem.imageList'(value){
      if(this.uploadedFiles.length === 0) {
        console.log(`imageList === ${JSON.stringify(value)}`)
        this.uploadedFiles = this.editedItem.imageList;
      }
    },
    visible(value){
      if (value === true){
        this.loadTypeData();
      }
    }
  },
  methods: {
    ...mapActions([
      "getProductType",
    ]),
    async loadTypeData() {
      const res = await this.getProductType();
      const list = res.data.data;
      this.kindList = list;
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList || !fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], fileList[x].name);
        const file = { name: fileList[x].name, image: fileList[x] };
        this.createImage(file);
      });
    },
    createImage(file) {
      const reader = new FileReader();
      let sortIndex = this.uploadedFiles.length > 0 ? this.uploadedFiles[this.uploadedFiles.length - 1].sort + 1 : 1;
      reader.onload = (e) => {
        const image = e.target.result;
        const fileData = { sort: sortIndex, image , url:''};
        console.log(`image ==${JSON.stringify(fileData)}`);
        this.uploadedFiles.push(fileData);
      };
      reader.readAsDataURL(file.image);
    },
    getFileType(type) {
      const name = type.toLowerCase();
      if (name.indexOf("jpeg") > -1 || name.indexOf("jpg") > -1) {
        return "jpg";
      }
      if (name.indexOf("png") > -1) {
        return "png";
      }
      return "";
    },
    confirmEvent() {
      this.editedItem.imageList = this.uploadedFiles;
      this.$emit("confirmEvent", this.editedItem);
    },
    cancelEvent() {
      this.$emit("cancelEvent");
    },
  },
};
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: white;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/RectifierEditDialog.vue